<template>
  <div class="w-full">
    <div
      class="flex flex-wrap w-full font-bold bg-gray-300 rounded text-gray-800 shadow-md mb-6"
    >
      <div class="flex-1 text-left py-3 px-4 w-full md:w-auto md:text-right">
        <router-link
          tag="button"
          to="/stringer/support/tickets/new"
          class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0"
        >
          New Ticket
        </router-link>
      </div>
    </div>

    <CustomTable class="bg-white rounded shadow-md group">
      <template v-slot:header>
        <th
          class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
        >
          Ticket ID
        </th>
        <th
          class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
        >
          Title Title
        </th>
        <th
          class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
        >
          Department
        </th>
        <th
          class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
        >
          Date
        </th>
        <th
          class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
        >
          Status
        </th>
        <th
          class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
        >
          Priority
        </th>
      </template>
      <template v-if="!polling" v-slot:body>
        <tr
          class="hover:bg-grey-lighter"
          v-for="ticket in tickets"
          v-bind:key="ticket.id"
        >
          <td class="py-4 px-6 border-b border-grey-light">
            <router-link
              :to="{
                name: 'StringerSupportViewTicket',
                params: { id: ticket.ticket_id }
              }"
              class="text-blue-600"
              >{{ ticket.ticket_id }}</router-link
            >
          </td>
          <td class="py-4 px-6 border-b border-grey-light">
            {{ ticket.title }}
          </td>
          <td class="py-4 px-6 border-b border-grey-light">
            {{ ticket.category.name }}
          </td>
          <td class="py-4 px-6 border-b border-grey-light">
            {{ ticket.created_at }}
          </td>
          <td class="py-4 px-6 border-b border-grey-light">
            {{ ticket.status }}
          </td>
          <td class="py-4 px-6 border-b border-grey-light">
            {{ ticket.priority }}
          </td>
        </tr>
        <tr class="bg-grey-lighter text-center" v-if="polling">
          <td class="py-5" colspan="4">
            <h1 class="text-xl"><i class="fa fa-circle-notch fa-spin"></i></h1>
          </td>
        </tr>
      </template>
    </CustomTable>
  </div>
</template>

<script>
import * as Config from "../../../config";
import { mapState, mapGetters } from "vuex";

import CustomTable from "@/components/general/CustomTable";

export default {
  name: "Support",
  data() {
    return {
      tickets: [],
      polling: true
    };
  },
  components: {
    CustomTable
  },
  mounted() {
    this.getTickets();
  },
  methods: {
    ...mapGetters(["getAuthorizationHeader"]),
    getTickets() {
      this.$http
        .get(
          Config.apiPath + "/api/v2/support/tickets",
          this.getAuthorizationHeader()
        )
        .then(response => {
          this.$set(this, "tickets", response.data);
          this.$set(this, "polling", false);
        });
    }
  }
};
</script>

<style scoped></style>
